"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.WidthVariant = void 0;
var React = _interopRequireWildcard(require("react"));
var _WidthWrapper = require("./WidthWrapper.style");
const WidthVariant = exports.WidthVariant = {
  NORMAL: 'NORMAL',
  NARROW: 'NARROW'
};
const WidthWrapper = _ref => {
  let {
    children,
    variant,
    withPadding,
    isMobile
  } = _ref;
  return /*#__PURE__*/React.createElement(_WidthWrapper.Wrapper, {
    variant: variant,
    withPadding: withPadding,
    isMobile: isMobile
  }, children);
};
WidthWrapper.defaultProps = {
  children: null,
  variant: WidthVariant.NORMAL,
  withPadding: true
};
var _default = exports.default = WidthWrapper;